<div class="job-role-container" [@slideInOut] (click)="$event.stopPropagation()" onKeyDown="">
    <div class="container-header">
        <div class="title">
            Job Role Selection
        </div>
        <div class="close-icon" (click)="onCloseClicked()" onKeyDown=""><i class="fa-solid fa-xmark"></i></div>
    </div>
    <div class="parent-checkbox-container">
        @for (field of dynamicFormArray['FieldsArray']; track idx; let idx = $index) {
        @if(field.fieldType === FieldType.CHECKBOX ) {
        <div class="main-checkbox-container">
            <div class="header">
                <span>{{field?.displayName}}</span>
                <button class="select-all-btn"
                    (click)="onFieldAllSelectedChange(field.fieldName, !fieldAllSelected[field.fieldName])"
                    [class.active]="fieldAllSelected[field.fieldName]">
                    <i [class]="fieldAllSelected[field.fieldName] ? 'fa-solid fa-square-check' : 'fa-regular fa-square'"></i>
                    Select All
                </button>
            </div>
            <div class="search-box-container">
                <i class="fa-solid fa-magnifying-glass search-icon"></i>
                <input
                    class="search-input"
                    type="text"
                    [placeholder]="'Filter ' + (field?.displayName ?? '')"
                    [(ngModel)]="searchFilters[field.fieldName]"
                />
                @if(searchFilters[field.fieldName]){
                <i class="fa-solid fa-xmark search-clear" (click)="clearSearch(field.fieldName)" onKeyDown=""></i>
                }
            </div>
            @if(field.isLoading){
            <div class="loading-indicator">
                <mat-progress-spinner diameter="20" mode="indeterminate" color="primary"
                    style="display: inline-block; vertical-align: middle;">
                </mat-progress-spinner>
                <span style="margin-left: 8px;">Fetching Records. Please wait...</span>
            </div>
            }@else{
            <app-distribution-list-checkbox-child [field]="field" [form]="form" [changedField]="changedField"
                [selectionTrigger]="fieldTriggers[field.fieldName]"
                [searchText]="searchFilters[field.fieldName]"
                (allSelectedChange)="onChildAllSelectedChange(field.fieldName, $event)"
                (selectionChange)="handleSelectionChange($event)"></app-distribution-list-checkbox-child>
            }
        </div>
        }
        }
    </div>

</div>